export const METABOT_V3_FEATURE = "metabot-v3";
export const OFFER_METABASE_MANAGED_AI_FEATURE = "offer-metabase-ai-managed";
export const METABASE_MANAGED_AI_FEATURE = "metabase-ai-managed";
export const METABASE_MANAGED_AI_PRODUCT_TYPE = "metabase-ai-managed";
export const METABASE_TIERED_AI_PRODUCT_TYPE = "metabase-ai-tiered";
export const METABASE_MANAGED_AI_TERMS_URL =
  "https://www.metabase.com/license/hosting";
export const METABASE_MANAGED_AI_UNIT_MULTIPLIER = 1_000_000;
